import React from 'react';
import InputCustom from "../../../../../../../../../../../../../components/InputCustom";

interface Props {
    onCpfChange: (value: string) => void;
    onJustificativaChange: (value: string) => void;
    cpfValue: string;
    justificativaValue: string;
}

const Content: React.FC<Props> = (props: Props) => {

    return (
        <div className="flex flex-col p-5">
            <InputCustom title="CPF do supervisor" typeInput="mask" mask="999.999.999-99" placeholder="Informe o cpf do supervisor" onChange={(value: string) => props.onCpfChange(value)} value={props.cpfValue} />
            <div className="mt-4">
                <label htmlFor="justificativa-estorno" className="block text-sm font-medium text-gray-700 mb-1">Justificativa</label>
                <div className="text-gray-500 mb-2">Motivo do estorno</div>
                <textarea
                    id="justificativa-estorno"
                    className="w-full min-h-32 rounded-md border border-[#DBDEDF] bg-white px-3 py-2 text-sm text-[#000] resize-y outline-none focus:border-[#0C4A85]"
                    value={props.justificativaValue}
                    onChange={(event) => props.onJustificativaChange(event.target.value)}
                    placeholder="Informe a justificativa"
                />
            </div>
        </div>
    )
}

export default Content;